const resources = [
  {
    category: "Passport Photos",
    icon: "ri-camera-line",
    items: [
      { name: "Walgreens — Fairbanks", address: "546 Gaffney Rd, Fairbanks, AK 99701", url: "https://www.walgreens.com/" },
      { name: "Fred Meyer — Fairbanks", address: "3755 Airport Way, Fairbanks, AK 99709", url: "https://www.fredmeyer.com/" },
      { name: "Fairbanks Main Post Office", address: "315 Barnette St, Fairbanks, AK 99701", url: "https://tools.usps.com/find-location.htm" },
    ],
  },
  {
    category: "Alaska DMV — ID Documents",
    icon: "ri-id-card-line",
    items: [
      { name: "DMV — Fairbanks Main", address: "1300 Peger Rd, Fairbanks, AK 99709", url: "https://doa.alaska.gov/dmv/" },
      { name: "Fairbanks North Star Borough Clerk", address: "809 Pioneer Rd, Fairbanks, AK 99701", url: "https://www.fnsb.gov/" },
    ],
  },
  {
    category: "Airports",
    icon: "ri-plane-line",
    items: [
      { name: "Fairbanks International Airport (FAI)", address: "6450 Airport Way, Fairbanks, AK 99709", url: "https://www.fai.alaska.gov/" },
      { name: "Eielson AFB (Military)", address: "517 Hangar Ave, Eielson AFB, AK 99702", url: "https://www.eielson.af.mil/" },
    ],
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Fairbanks Passport Applicants
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Local businesses and offices in Fairbanks that can help you prepare your passport application.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {resources.map((group, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${group.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-4">{group.category}</h3>
              <ul className="space-y-4">
                {group.items.map((item, j) => (
                  <li key={j} className="border-t border-gray-100 pt-3">
                    <a href={item.url} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#1A365D] text-xs flex items-center gap-1 hover:text-[#F6C344] transition-colors group cursor-pointer">
                      {item.name}
                      <i className="ri-external-link-line text-[10px] text-gray-400 group-hover:text-[#F6C344]"></i>
                    </a>
                    <p className="text-gray-400 text-xs mt-0.5">{item.address}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">
            Other Alaska cities we serve:
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              { name: "Alaska State Hub", href: "/alaska" },
              { name: "Anchorage", href: "/anchorage" },
              { name: "Juneau", href: "/juneau" },
            ].map((city) => (
              <a
                key={city.href}
                href={city.href}
                className="text-sm font-semibold text-[#1A365D] hover:text-[#F6C344] transition-colors whitespace-nowrap underline underline-offset-2"
              >
                {city.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}